import * as React from "react";
import MainNavigation from "./components/navigation/mainNavigation";
import Content from "./components/content/content";
import HeaderComponent from './components/header/headerComponent';
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import OfflineStatusComponent from './common/components/offlineStatus/offlineStatusComponent';
import Fab from '@material-ui/core/Fab';
import Chat from '@material-ui/icons/Chat';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import blue from '@material-ui/core/colors/blue';
import * as Constants from './common/constants';
import FooterComponent from './components/footer/footer';
import ChatComponent from './components/chatBot/chatComponent';
import Translate from "./common/functions/translate";

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiIconButton: {
      root: {
        padding: '0px',
        paddingRight: '5px'
      }
    },
    MuiTypography: {
      h6: {
        fontSize: '1.2em'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '100%'
      }
    },
    MuiFab: {
      root: {
        boxShadow: '1px'
      }
    }
  },
  palette: {
    primary: blue
  },
});

interface IState {
  isVisibleChat: boolean
}

interface IProps {
  location?: any,
  match?: any
}

class App extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isVisibleChat: false
    }
  }

  public render() {
    if (window.innerWidth >= Constants.device.desktop) {
      theme.overrides = { ...theme.overrides, MuiDialog: { paper: { maxWidth: '80% !important', margin: 0 } } }
    }

    let isChatbotMobilePath = window.location.pathname && window.location.pathname == '/chatbot';

    return (
      <>
        {isChatbotMobilePath ?
          <BrowserRouter>
            <Content />
          </BrowserRouter>
          :
          <BrowserRouter>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div>

                  <div className="floating-action-button-left">
                    <Fab color="secondary" aria-label="Add" size="medium" onClick={() => this.setState({ isVisibleChat: true })} >
                      <Chat />
                    </Fab>
                    {window.innerWidth >= Constants.device.desktop ?
                      <div className="chat-action-button-text">
                        {Translate('Chatbot')}
                      </div>
                      : null}
                  </div>

                  {this.state.isVisibleChat ?
                    <ChatComponent isVisible={this.state.isVisibleChat} closeDialog={() => this.setState({ isVisibleChat: false })}></ChatComponent>
                    : null}

                  <div>
                    <HeaderComponent />
                  </div>

                  <OfflineStatusComponent />

                  <div>
                    <Content />
                  </div>

                  <div className="app-navigation">
                    <MainNavigation />
                  </div>

                  <div className="app-footer-web">
                    <FooterComponent />
                  </div>

                  <CookieConsent
                    location="bottom"
                    buttonText="OK"
                    cookieName="MedXchangeCookieConsent"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
                    buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                    expires={150}
                  >
                    We have placed cookies on your device to help make this website better. If you don't close the website we’ll assume you’re OK to continue.{" "}
                    <Link to='/cookie-policy' style={{ color: 'orange' }}>Read more</Link>
                  </CookieConsent>

                </div>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>

          </BrowserRouter>
        }
      </>


    );
  }
}

export default App;
